const replaceMaterialWord = (text, materialColor) => {
  if (!materialColor) {
    return text
      .replace("[colour]", "")
      .replace("[Colour]", "")
      .replace("[color]", "")
      .replace("[Color]", "")
      .replace("[couleur]", "")
      .replace("[Couleur]", "")
      .replace(/\s+/g, " ")
  } else if (text.includes("[colour]") || text.includes("[color]")) {
    return text
      .replace("[colour]", materialColor)
      .replace("[color]", materialColor)
      .replace("[couleur]", materialColor)
  } else if (
    text.includes("[Colour]") ||
    text.includes("[Color]") ||
    text.includes("[Couleur]")
  ) {
    return text
      .replace(
        "[Colour]",
        materialColor.charAt(0).toUpperCase() + materialColor.slice(1)
      )
      .replace(
        "[Color]",
        materialColor.charAt(0).toUpperCase() + materialColor.slice(1)
      )
      .replace(
        "[Couleur]",
        materialColor.charAt(0).toUpperCase() + materialColor.slice(1)
      )
  } else {
    return text
  }
}


module.exports = {
  replaceMaterialWord: replaceMaterialWord,
}
